import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { buildRoleGateNotice, ROLE_GATE_NOTICE_KEY } from './roleGateNotice';

function RoleGate({ check, children, fallback = '/dashboard' }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!check(user)) {
    return (
      <Navigate
        to={fallback}
        replace
        state={{
          [ROLE_GATE_NOTICE_KEY]: buildRoleGateNotice(location.pathname),
        }}
      />
    );
  }

  return children;
}

export default RoleGate;
